export default __webpack_public_path__ + "static/media/right_character.416c09b1.png";